<template>
  <a
    v-if="isExternal && typeof to === 'string'"
    v-bind="$attrs"
    :href="to"
    :target="target == '_blank' ? '_blank' : '_self'"
    rel="noopener"
  >
    <slot />
  </a>
  <RouterLink v-else :to="to" v-bind="$attrs">
    <slot />
  </RouterLink>
</template>

<script setup lang='ts'>
import { computed } from 'vue';
import { RouterLink, type RouterLinkProps } from 'vue-router';

defineOptions({
  inheritAttrs: false,
});

const props = defineProps<{
  to: string | RouterLinkProps['to'];
  target?: string;
}>();

const isExternal = computed(() => typeof props.to === 'string' && props.to.startsWith('http'));
</script>


